<template>
  <a class="live-program-button" :href="to.el" v-scroll-to="to">ニコニコQ LIVE 出題予定の番組表</a>
</template>

<script>
export default {
  data() {
    return {
      to: { el: '#program-list', offset: -120 },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../constants/style';

.live-program-button {
  background: #eb5757;
  border-radius: 9999px;
  color: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 64px;
  height: 64px;
  width: 284px;
  transition: background 0.3s ease-out;

  &:hover {
    background: #ce3f3f;
  }
}
</style>
